import React from 'react'
import '../../styles/flash-client.sass'
import file from '../../img/File icon.svg'
import {useHistory} from 'react-router-dom'
import {files} from '../files'
import adv_1 from '../../img/adv_1.png'
import adv_2 from '../../img/adv_2.png'
import adv_3 from '../../img/adv_3.png'
import effect from '../../img/effect.png'
import pilot from '../../img/pilot.png'
import dashboard_1 from '../../img/dashboard_1.jpg'
import dashboard_2 from '../../img/dashboard_2.jpg'

const FlashClientComponent = () => {
    const history = useHistory()

    return (
        <div className="flash-client">

            <div className="block learn">
                <div className="block-title">
                    Узнайте больше о своих клиентах<br/> и повысьте эффективность бизнеса
                </div>
                <div className="block-text">
                    FlashClient – инновационная нейросеть, работающая на базе камер видеонаблюдения, предназначенная для сбора и анализа
                    посещения клиентами АЗС, через связку номера авто и транзакции.
                    <br/><br/>
                    Изучайте аналитику по каждой АЗС, по регионам или по всей сети
                </div>
            </div>

            <div className="block problems">
                <div className="block-title center">
                    Проблемы,с которыми сталкиваются сети АЗС
                </div>
                <div className="problems-container">
                    <div><p>Мы ничего не знаем о 10-50 % клиентов, которые не пользуются системой лояльности</p></div>
                    <div><p>Невозможно определить отток клиентов</p></div>
                    <div><p>Невозможно определить средний пролив и частотность на одного покупателя, а не на транзакцию</p></div>
                    <div><p>Невозможно определить количество новых клиентов</p></div>
                </div>
            </div>

            <div className="block stages">
                <div className="block-title center">
                    Основные этапы работы системы
                </div>
                <div className="stages-container">
                    <div className='stage'>
                        <p className='stage-title'>ЗАХВАТ ИЗОБРАЖЕНИЯ</p>
                        <p className='stage-text'>Захват видеопотока с камеры установленной на АЗС</p>
                    </div>
                    <div className='stage'>
                        <p className='stage-title'>ДЕТЕКЦИЯ НОМЕРА</p>
                        <p className='stage-text'>Детекция номера авто на захваченных кадрах и отправка их на сервер</p>
                    </div>
                    <div className='stage'>
                        <p className='stage-title'>РАСПОЗНАВАНИЕ НОМЕРА</p>
                        <p className='stage-text'>Распознавание номера авто в облаке</p>
                    </div>
                    <div className='stage'>
                        <p className='stage-title'>СОПОСТАВЛЕНИЕ ДАННЫХ</p>
                        <p className='stage-text'>Сопоставление номера авто с транзакцией</p>
                    </div>
                </div>
            </div>

            <div className="block advantages">
                <div className="block-title center">
                    Преимущества системы
                </div>
                <div className="advantages-container">
                    <div className='advantage'>
                        <div className="image">
                            <img src={adv_1}/>
                        </div>
                        <p className='advantage-title'>СЛЕДИТЕ ЗА ПРИТОКОМ НОВЫХ КЛИЕНТОВ</p>
                        <p className='advantage-text'>Отслеживайте количество новых клиентов и их средний чек,
                            чтобы анализировать эффективность маркетинговых мероприятий и темпов развития клиентской базы на новых АЗС в динамике</p>
                    </div>
                    <div className='advantage'>
                        <div className="image">
                            <img src={adv_2}/>
                        </div>
                        <p className='advantage-title'>И КОНТРОЛИРУЙТЕ ОТТОК ДЕЙСТВУЮЩИХ</p>
                        <p className='advantage-text'>Определив отток клиентов на АЗС, вы сможете вовремя определить причины, принять меры
                            и сохранить клиентскую базу на высококонкурентном рынке</p>
                    </div>
                    <div className='advantage'>
                        <div className="image">
                            <img src={adv_3}/>
                        </div>
                        <p className='advantage-title'>ИЗУЧИТЕ РЕАЛЬНУЮ ЧАСТОТУ И ОБЪЕМ ЗАПРАВОК</p>
                        <p className='advantage-text'>Следите за реальными данными и запускайте реально эффективные
                            акции, не ориентируясь на «среднюю температуру по больнице»</p>
                    </div>
                </div>
            </div>

            <div className="block center dashboard">
                <div className="block-title">
                    Примеры аналитических дашбордов
                </div>
                <img src={dashboard_1}/><br/><br/>
                <img src={dashboard_2}/>
            </div>

            <div className="block center">
                <div className="block-title">
                    Реальный эффект для бизнеса, а не аналитика <br/>ради аналитики
                </div>

                <img src={effect}/><br/><br/>

                <div className="block-text">
                    Используйте маркетинговые инструменты<br/> в зависимости от полученных данных
                </div>
            </div>

            <div className="block pilot">
                <div className="pilot-container">
                    <div className="block-title">
                        Примите участие в пилотном запуске
                    </div>
                    <div className="block-text">
                        Получите максимум эффективности за минимальную цену,
                        запустив продукт на ранней стадии развития
                    </div>
                </div>
                <div className="image">
                    <img src={pilot}/>
                </div>
            </div>

            <div className='order'>
                <div className='files' onClick={() => {
                    window.open(`${files.install}`, '_blank')
                }}>
                    <img src={file} alt='file-icon'/><p>Скачать презентацию</p>
                </div>
                <div className='button button__default'>
                    <button onClick={() => {
                        history.push('/feedback')
                    }}>Оставить заявку
                    </button>
                    <div className='background'></div>
                </div>
            </div>
        </div>
    )
}

export default FlashClientComponent